/**
 * calculate offset from node, to current scrollTop of the window
 * @param node - DOM node
 * @param isBottom - if true, returns bottom offset, otherwise top offset
 * @returns number of pixels from window top edge, negative if left behind scroll, null on error
 */
export const getNodeScrollOffset = (node, isBottom) => {
  if (typeof node !== 'object' || node === null || !('getBoundingClientRect' in node)) return null;
  if (isBottom) return node.getBoundingClientRect().bottom;
  return 0 - node.getBoundingClientRect().top;
};
